import React from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

export type SortBy = "title" | "closingDate" | "createdAt";
export type SortOrder = "asc" | "desc";

interface SortControlsProps {
  sortBy: SortBy;
  sortOrder: SortOrder;
  onSortByChange: (sortBy: SortBy) => void;
  onSortOrderChange: (sortOrder: SortOrder) => void;
  className?: string;
}

export default function SortControls({
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
  className,
}: SortControlsProps) {
  const { t } = useTranslation();
  const sortByLabels: Record<SortBy, string> = {
    title: t("crm.sortByTitle"),
    closingDate: t("crm.sortByClosingDate"),
    createdAt: t("crm.sortByCreatedAt"),
  };
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className="text-sm text-muted-foreground whitespace-nowrap">
        {t("crm.sortBy")}
      </span>
      <Select value={sortBy} onValueChange={onSortByChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="title">{sortByLabels.title}</SelectItem>
          <SelectItem value="closingDate">{sortByLabels.closingDate}</SelectItem>
          <SelectItem value="createdAt">{sortByLabels.createdAt}</SelectItem>
        </SelectContent>
      </Select>

      <Button
        variant="outline"
        size="sm"
        onClick={() => onSortOrderChange(sortOrder === "asc" ? "desc" : "asc")}
        className="h-10 px-3"
        title={sortOrder === "asc" ? t("crm.sortOrderAsc") : t("crm.sortOrderDesc")}
      >
        {sortOrder === "asc" ? (
          <ArrowUp className="h-4 w-4" />
        ) : (
          <ArrowDown className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}


